export default (props) => {
	return (
		<div
			data-react="Slide"
			class={`flex items-center justify-center min-w-full h-full carousel-slide py-8 px-12 md:px-24 bg-gray-200 ${
				props.isAdmin ? "my-4" : ""
			}`}
		>
			<div class="w-full">{props.children}</div>
		</div>
	);
};
